import { render, staticRenderFns } from "./ciLeiHuoYong.vue?vue&type=template&id=3b9d50b2&scoped=true&"
import script from "./ciLeiHuoYong.vue?vue&type=script&lang=js&"
export * from "./ciLeiHuoYong.vue?vue&type=script&lang=js&"
import style0 from "./ciLeiHuoYong.vue?vue&type=style&index=0&id=3b9d50b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d50b2",
  null
  
)

export default component.exports